'use strict';

angular.module('licensure.services')
    .factory('IPChecklists', ['$http', '$q', '$rootScope', '$timeout', '$compile', 'FBResponses', 'Documents', 'IPComment', 'Logger', function ($http, $q, $rootScope, $timeout, $compile, FBResponses, Documents, IPComment, Logger) {

        return {
            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPChecklists/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (checklist, inspection_id) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPChecklists/';
                if (!isUndefined(checklist.id)) {
                    method = 'PUT';
                    url += checklist.id;
                }

                // need to run the saveByForm function to do some processing to the form answers, but don't want it to actually save in the process (set dont_save to true)
                FBResponses.saveByForm(checklist.response, inspection_id, null, null, true, true).then(function (processedResponse) {
                    if (processedResponse != null) {
                        checklist.response = processedResponse;

                        $http({
                            method: method,
                            url: url,
                            data: {
                                checklist: checklist,
                                inspection_id: inspection_id
                            }
                        }).then(function (response) {
                            d.resolve(response.data);
                        }).catch(function (response) {
                            Logger.logAngularApiErrors(response.data, response.status, response.config);
                            d.resolve(null);
                        });
                    }
                    else {
                        d.resolve(null);
                    }
                });

                return d.promise;
            },

            updateBatch: function (checklists) {
                var d = $q.defer();

                var promises = [];

                var method = 'POST';
                var url = apiLocation + '/api/IPChecklists/saveBatch';

                // shouldn't do it this way, try going back to the start of the batch function and handling the creates and updates separately
                var isUpdate = checklists.every(function (checklist) {
                    return !isUndefined(checklist.id);
                });

                if (isUpdate) {
                    method = 'PUT';
                    url = apiLocation + '/api/IPChecklists/updateBatch';
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        checklists: checklists
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    Logger.logAngularApiErrors(response.data, response.status, response.config);
                    d.resolve(null);
                });

                return d.promise;
            },

            getDocumentsAndComments: function (inspection) {
                var d = $q.defer();

                Documents.getDocumentsByInspection(inspection.id).then(function (documents) {
                    if (document != null) {
                        inspection.documents = documents;

                        IPComment.listIPCommentAsync(inspection.id).then(function (comments) {
                            if (comments != null) {
                                inspection.comments = comments;
                                d.resolve(inspection);
                            }
                            else {
                                d.resolve(null);
                            }
                        });

                    }
                    else {
                        d.resolve(null);
                    }
                });

                return d.promise;
            },

            generatingPDF: function (inspection) {
                var d = $q.defer();
                var pdfScope = $rootScope.$new(true, $rootScope);
                pdfScope.inspection = angular.copy(inspection);
                var element = $compile('<inspection-pdf inspection="inspection"></inspection-pdf>')(pdfScope);

;                pdfScope.$on('$destroy', function () {
                    inspection = null;
                    $timeout.cancel(timer);
                    if (pdfScope) {
                        pdfScope.$destroy();
                        pdfScope.inspection = null;
                        pdfScope = null;
                    }
                    if (element) {
                        angular.element(element).off();
                        angular.element(element).remove();
                        element = null;
                    }
                });
                var timer = $timeout(function () {
                    $http.post(apiLocation + '/api/IPChecklists/generatepdf', {
                        html: element.html(),
                        checklistID: inspection.checklist.id,
                        inspectionID: inspection.id,
                        visitID: inspection.visit_id,
                        name: inspection.number,
                        outcome: inspection.outcome,
                        signatureTypeInPerson: inspection.checklist.signature_type_in_person
                    })
                        .then(function (response) {
                            pdfScope.inspection = null;
                            angular.element(element).off();
                            angular.element(element).remove();
                            pdfScope.$destroy();
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            // handle error:
                            pdfScope.inspection = null;
                            angular.element(element).off();
                            angular.element(element).remove();
                            pdfScope.$destroy();
                            d.resolve(false);

                        });
                }, 50); //Delayed 50 milliseconds before excuting the function. 

                return d.promise;
            },

            //The `generatePDF` method is still used by the submission of checklists in the public portal.
            generatePDF: function (inspection) {
                var d = $q.defer();

                Documents.getDocumentsByInspection(inspection.id).then(function (documents) {
                    inspection.documents = documents;

                    IPComment.listIPCommentAsync(inspection.id).then(function (comments) {
                        inspection.comments = comments;

                        var pdfScope = $rootScope.$new(true, $rootScope);
                        pdfScope.inspection = angular.copy(inspection);
                        var element = $compile('<inspection-pdf inspection="inspection"></inspection-pdf>')(pdfScope);

                        pdfScope.$on('$destroy', function () {
                            inspection = null;
                            $timeout.cancel(timer);
                            if (pdfScope) {
                                pdfScope.$destroy();
                                pdfScope.inspection = null;
                                pdfScope = null;
                            }
                            if (element) {
                                angular.element(element).off();
                                angular.element(element).remove();
                                element = null;
                            }
                        });
                        var timer = $timeout(function () {
                            $http.post(apiLocation + '/api/IPChecklists/generatepdf', {
                                html: element.html(),
                                checklistID: inspection.checklist.id,
                                inspectionID: inspection.id,
                                visitID: inspection.visit_id,
                                name: inspection.number,
                                outcome: inspection.outcome,
                                signatureTypeInPerson: inspection.checklist.signature_type_in_person
                            }).
                                then(function (response) {
                                    pdfScope.inspection = null;
                                    angular.element(element).off();
                                    angular.element(element).remove();
                                    pdfScope.$destroy();
                                    d.resolve();
                                }).
                                catch(function (response) {
                                    pdfScope.inspection = null;
                                    angular.element(element).off();
                                    angular.element(element).remove();
                                    pdfScope.$destroy();
                                    // handle error
                                });
                        }, 50);
                    });
                });

                return d.promise;
            }
        };
    }])
;